package com.iptvplayer.shared.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class Device(
    val id: String,
    val userId: String,
    val name: String,
    val platform: DevicePlatform,
    val isOnline: Boolean,
    val lastSeenAt: Long,
    val registeredAt: Long
)

@Serializable
enum class DevicePlatform {
    ANDROID_MOBILE,
    ANDROID_TV,
    IOS,
    WEB
}
